import { Box, type BoxProps, styled } from "@mui/material";

export type FlexBoxProps = BoxProps;

export const FlexBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
}));
